import { HomeService } from '../../services/homeService';
import messages from './newsletter-modal-translations';
import * as $ from 'jquery';

export default {
    name: 'instamapsNewsletterModal',
    data() {
        return {
            submitSuccess: false,
            submitError: false,
        };
    },
    i18n: {
        messages,
    },
    props: {
        delay: { type: Number },
    },
    methods: {
        show: function () {
            setTimeout(function () {
                $('#newsletter-modal').addClass('animate-flex-modal');
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#newsletter-modal').removeClass('animate-flex-modal');
            this.submitError = false;
            this.submitSuccess = false;
        },
        submit: function () {
            let json = JSON.stringify({ email: $('#newsletter-modal #email').val() });
            HomeService.httpPostNewsletterSubscribe(json).then((response) => {

                if (response.status === 200 || response.status === 202) {
                    this.submitError = false;
                    this.submitSuccess = true;

                    setTimeout(this.dismiss, 3000);

                } else {
                    this.submitError = true;
                    this.submitSuccess = false;
                }
                $('#newsletter-modal #email').val('');
            });
        },
    },
    mounted() {
        this.$on('showNewsletterModal', this.show());
    },
};



// WEBPACK FOOTER //
// ./src/home-geolocal/components/newsletter-modal/newsletter-modal.js